module.exports = __webpack_public_path__ + "img/vertical_5_1_8004.2fe4194e.png";